/// <reference path="../_references.ts"/>

module App.DispatchSummary {
	angular.module('dispatchSummary.table', [])
		.directive('dispatchSummaryTable', [function() {
			return {
				restrict: 'E',
				scope: {
					serviceRequests: '=',
					tableTitle: '='
				},
				templateUrl: 'html/dispatch-summary/dispatch-summary-table.tpl.html',
				controllerAs: 'summaryTable',
				controller: ['$scope', 'ModalService', function($scope: any, ModalService: any) {
					const vm = this;

					vm.dctrl = $scope.$parent.dctrl;

					vm.showModal = (sr: ServiceRequest) => {
						var modalOptions = {
							templateUrl: 'html/dispatch-summary/dispatch-summary-panel.tpl.html',
							controller: ['close', function(close: () => {}) {
								this.sr = sr;
								this.close = () => {
									close();
								};
							}],
							controllerAs: 'panel',
							backdrop: 'static',
							keyboard: true
						};
						ModalService.showModal(modalOptions);
					};
				}]
			}
		}]);
}